export default __webpack_public_path__ + "static/media/Tiger's Gauntlets of the Roaring Jungle.5faa8b62.jpg";